import {PartnerSummaryModel} from '../../../../common/api/model/partnerSummary.model';
import {PartnerPersonSummaryModel} from './partnerPersonSummary.model';
import {AddressModel} from "../../../../../common/entity/address.model";

export class PartnerPersonModel {
    partner: PartnerSummaryModel;
    summary: PartnerPersonSummaryModel;
    mainAddress: AddressModel;
}


export enum PartnerPersonType {
    PATIENT = 'PARTNER_PERSON_TYPE_PATIENT',
    MAIN = 'PARTNER_PERSON_TYPE_MAIN',
}